import React from 'react'
import { object } from 'prop-types'
import { CreditCardOutlined } from '@ant-design/icons'
import MaskedInput from 'antd-mask-input'
import { Widget, useUpdate, useValidation } from './base/widget'
import { CommonFields } from './base/widgetCommonFields'
import { FormItem, styleIconValidation } from './base/styles'
import { validateCNPJ } from '../../../../../utils'

export const CnpjWidget = React.memo((props) => {
	const { data } = props

	const update = useUpdate(props)
	const [valid, setValid] = useValidation(props)

	return (
		<Widget
			{...props}
			icon={<Icon $error={!valid} />}
			onValidate={setValid}
			type={'CNPJ'}
			formItems={
				<div>
					<CommonFields data={data} update={update} />
					<FormItem label="Valor inicial" $width={'50%'}>
						<MaskedInput
							value={data.initialValue}
							onBlur={(e) => update({ initialValue: e.target.value })}
							rules={() => ({
								validator(rule, value) {
									if (!value) {
										return Promise.resolve()
									} else {
										if (validateCNPJ(value)) return Promise.resolve()
										else return Promise.reject('CNPJ não é válido.')
									}
								},
							})}
							mask="00.000.000/0000-00"
						/>
					</FormItem>
				</div>
			}
		/>
	)
})

const Icon = styleIconValidation(CreditCardOutlined)

CnpjWidget.propTypes = {
	data: object,
}
